var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTechwork1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.013,
    height: 68,
    viewBox: "0 0 68.013 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15108",
    "data-name": "Group 15108",
    transform: "translate(-733.099 -210.031)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41117",
    "data-name": "Path 41117",
    d: "M755.833,210.031a8.451,8.451,0,0,0,1.792.625c.314.106.434.212.326.552q-.868,2.712-1.7,5.431c-.1.32-.248.376-.526.276l-.062-.022c-.624-.212-1.509-.248-1.8-.685-.3-.452.25-1.215.44-1.838.442-1.453.929-2.895,1.4-4.34Z",
    transform: "translate(20.711 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41118",
    "data-name": "Path 41118",
    d: "M770.465,223.634c-1.846.43-3.627,1.077-5.429,1.652-.657.21-.887.108-1.071-.557-.46-1.649-.493-1.639,1.141-2.146,1.367-.424,2.737-.839,4.1-1.283.374-.122.542-.068.665.332a7.943,7.943,0,0,0,.6,1.736Z",
    transform: "translate(30.648 11.232)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41119",
    "data-name": "Path 41119",
    d: "M777.445,238.713a1.831,1.831,0,0,1-.562,1.307c-.939.937-1.872,1.882-2.833,2.8a7.347,7.347,0,0,1-2.592,1.567q-6.57,2.387-13.13,4.792a.747.747,0,0,1-.925-.192q-6.366-6.354-12.76-12.676a.7.7,0,0,1-.178-.869q2.405-6.6,4.78-13.206a7.72,7.72,0,0,1,1.784-2.843c.839-.851,1.68-1.7,2.534-2.534a1.754,1.754,0,0,1,2.737.008q10.26,10.248,20.511,20.5A1.965,1.965,0,0,1,777.445,238.713Z",
    transform: "translate(11.31 6.184)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41120",
    "data-name": "Path 41120",
    d: "M744.245,260.848a4.936,4.936,0,0,1-3.743-1.487c-1.974-1.968-3.96-3.928-5.911-5.919a4.735,4.735,0,0,1,.04-6.934q9.521-9.543,19.051-19.071c.32-.322.495-.346.831-.012q6.033,6.033,12.1,12.029c.314.31.3.472,0,.775q-9.591,9.564-19.161,19.148A4.687,4.687,0,0,1,744.245,260.848Zm12.772-22.112c-.088-.106-.16-.21-.248-.3-.342-.344-.715-.665-1.023-1.037-.338-.406-.567-.454-.961-.024-.8.879-1.686,1.686-2.512,2.544-.454.472-1.305.889-1.253,1.431.05.514.841.947,1.281,1.439.248.276.41.288.681.01,1.251-1.277,2.524-2.534,3.789-3.8C756.846,238.922,756.918,238.84,757.016,238.736Z",
    transform: "translate(0 17.183)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41121",
    "data-name": "Path 41121",
    d: "M766.638,216.16c-.082.09-.15.174-.228.252q-2.834,2.838-5.665,5.675c-.214.214-.35.264-.577.018-.4-.438-.829-.859-1.263-1.267-.216-.2-.188-.328.012-.526q2.868-2.85,5.719-5.717c.176-.178.294-.2.476-.014.442.462.9.909,1.355,1.363A2.652,2.652,0,0,1,766.638,216.16Z",
    transform: "translate(25.702 4.426)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechwork1);
export default __webpack_public_path__ + "static/media/techwork1.4e2195d09d197101b5bc83f79380c6db.svg";
export { ForwardRef as ReactComponent };